import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, Teleport as _Teleport, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "boundary-plus"
}
const _hoisted_2 = { class: "boundary-plus__top" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "boundary-plus__heading" }, " Boundary + ", -1 /* HOISTED */)
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "boundary-plus__empty"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "No Boundary + content yet.", -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "boundary-plus__groups"
}
const _hoisted_9 = { class: "boundary-plus__group-header" }
const _hoisted_10 = { class: "boundary-plus__group-title-row" }
const _hoisted_11 = { class: "boundary-plus__group-month" }
const _hoisted_12 = { class: "boundary-plus__group-year" }
const _hoisted_13 = {
  key: 0,
  class: "boundary-plus__group-actions"
}
const _hoisted_14 = {
  key: 2,
  class: "simple-modal-wrapper",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_15 = { class: "simple-modal" }
const _hoisted_16 = { class: "simple-modal__buttons" }
const _hoisted_17 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      ($setup.loading)
        ? (_openBlock(), _createBlock($setup["PageLoaderComponent"], { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            ($setup.show_upsell)
              ? (_openBlock(), _createBlock($setup["BoundaryPlusUpsellComponent"], {
                  key: 0,
                  project: $props.project
                }, null, 8 /* PROPS */, ["project"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    ($props.viewMode === 'staff' && $setup.is_staff_admin)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "button button--fill",
                          disabled: !$setup.has_checked_items,
                          onClick: _cache[0] || (_cache[0] = $event => ($setup.show_delete_confirm = true))
                        }, " Delete image/video ", 8 /* PROPS */, _hoisted_4))
                      : _createCommentVNode("v-if", true)
                  ]),
                  (!$setup.groups_with_items.length && !$setup.loading && !$setup.is_staff_admin)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groups_with_items, (group) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: group.month,
                            class: "boundary-plus__group"
                          }, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("h3", _hoisted_11, _toDisplayString(group.month_name), 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(group.year), 1 /* TEXT */)
                              ]),
                              ($setup.is_staff_admin)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createVNode($setup["LightswitchComponent"], {
                                      label: "Publish",
                                      "off-label": "Publish",
                                      checked: group.is_published,
                                      disabled: $setup.publishing_month === group.month,
                                      onChange: $event => ($setup.togglePublishMonth( group ))
                                    }, null, 8 /* PROPS */, ["checked", "disabled", "onChange"])
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ]),
                            (group.masonry_items.length)
                              ? (_openBlock(), _createBlock($setup["MasonryWall"], {
                                  key: 0,
                                  items: group.masonry_items,
                                  "column-width": 250,
                                  gap: 8,
                                  "max-columns": 4,
                                  "key-mapper": $setup.key_mapper
                                }, {
                                  default: _withCtx(({ item }) => [
                                    (item.type === 'boundary_plus_upload')
                                      ? (_openBlock(), _createBlock($setup["BoundaryPlusUploadComponent"], {
                                          key: 0,
                                          project: $props.project,
                                          onUploadComplete: $setup.loadItems
                                        }, null, 8 /* PROPS */, ["project"]))
                                      : (_openBlock(), _createBlock($setup["BoundaryPlusThumbnailComponent"], {
                                          key: 1,
                                          item: item,
                                          "is-staff": $setup.is_staff_admin,
                                          checked: $setup.checked_ids.includes( item.id ),
                                          onOpen: $event => ($setup.openModal( group.items, item )),
                                          onCheck: $setup.toggleCheck,
                                          onImageLoaded: $setup.on_image_loaded
                                        }, null, 8 /* PROPS */, ["item", "is-staff", "checked", "onOpen"]))
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["items"]))
                              : _createCommentVNode("v-if", true)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                ], 64 /* STABLE_FRAGMENT */)),
            (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
              ($setup.show_modal && $setup.modal_options)
                ? (_openBlock(), _createBlock($setup["BoundaryPlusGalleryModalComponent"], {
                    key: 0,
                    options: $setup.modal_options,
                    onCloseModal: $setup.closeModal
                  }, null, 8 /* PROPS */, ["options"]))
                : _createCommentVNode("v-if", true)
            ])),
            ($setup.show_delete_confirm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("p", null, "Are you sure you want to delete the selected " + _toDisplayString($setup.checked_ids.length === 1 ? 'item' : `${$setup.checked_ids.length} items`) + "?", 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("button", {
                        class: "button button--large button--destructive",
                        disabled: $setup.deleting,
                        onClick: $setup.deleteCheckedItems
                      }, _toDisplayString($setup.deleting ? 'Deleting…' : 'Delete'), 9 /* TEXT, PROPS */, _hoisted_17),
                      _createElementVNode("button", {
                        class: "button button--large button--secondary",
                        onClick: _cache[1] || (_cache[1] = $event => ($setup.show_delete_confirm = false))
                      }, " Cancel ")
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]))
    ]),
    _: 1 /* STABLE */
  }))
}